import Button from 'app/shared/components/button/Button';
import styled from 'styled-components/macro';
import styledFuncs from 'app/styles/styledFuncs';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import { useEffect, useState } from 'react';
import { useGetPaymentMethod } from 'app/core/api/user/api-user';
import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import { useWatchAsRef } from 'app/tools/hooks/misc-hooks';
import {
  PaymentMethod,
  QuoteSummery,
} from 'app/core/api/repairer/api-repairer.types';
import {
  CloseSquare,
  SelectorSvg,
  ConfirmSvg,
} from 'app/shared/components/icon/icon-lib';
import QuoteDetails from './quote-details';
import Cards from '../Payment/Card';

type Props = {
  sending?: boolean;
  setPaymentMethodId: (paymentMethodId: string) => unknown;
  createOrder: () => unknown;
  paymentMethodId: string;
  quoteSummery: QuoteSummery;
};
export default function QuotePaymentDetails({
  sending,
  setPaymentMethodId,
  createOrder,
  paymentMethodId,
  quoteSummery,
}: Props): JSX.Element {
  const {
    resource: cardlist,
    loading,
    loadingMissing,
    request,
  } = useGetPaymentMethod();
  const loadingRef = useWatchAsRef(loading);
  const titleMsg = loadingMissing ? 'Loading...' : `Card List`;
  const [showAddCard, setShowAddCard] = useState(false);
  const [preAuthMessageVisible, setPreAuthMessageVisible] =
    useState(true);
  useEffect(() => {
    if (!loadingRef.current) request();
  }, [loadingRef, request, showAddCard]);
  useSetPageTitle(titleMsg);
  const CardContainer = styled.div`
    background: #31ad31;
    border-radius: 10px;
    position: relative;
    height: ${styledFuncs.pad(9.6)};
    padding: ${styledFuncs.pad(1.5)};
    span {
      margin-bottom: ${styledFuncs.pad(1)};
      color: white;
      weight: bold;
    }
    .payNowButton {
      border-radius: 50px;
      margin-bottom: 10px;
    }
    .payNowButton span {
      margin-bottom: 0px;
    }
  `;
  const PreAmount = styled.text`
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    position: absolute;
    right: ${styledFuncs.pad(1.5)};
  `;
  const CardHolder = styled.div`
    position: absolute;
    left: 10px;
    right: 10px;
    top: ${styledFuncs.pad(6.4)};
  `;
  const Card = styled.div`
    background: white;
    border-radius: 10px;
    min-height: ${styledFuncs.pad(5.8)};
    padding: ${styledFuncs.pad(1)};
    margin-bottom: ${styledFuncs.pad(2)};
    filter: drop-shadow(0px 3px 10px rgba(0, 0, 0, 0.161));
    span {
      color: #31ad31;
      weight: bold;
    }
  `;
  const PreAuthTag = styled.div`
    font-style: normal;
    font-weight: 600;
    color: #31ad31;
  `;
  const PreAuthText = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    color: #000000;
  `;
  const CloseButton = styled.div`
    position: absolute;
    width: 22px;
    height: 22px;
    right: 0;
    top: calc(50% - 22px / 2 - 37px);
    background: #ffffff;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.161);
    border-radius: 6px;
    text-align: center;
    padding: 4px;
  `;
  useEffect(() => {
    if (cardlist?.data?.length === 1) {
      setPaymentMethodId(cardlist?.data[0].paymentMethodId);
    }
  }, [cardlist, paymentMethodId, setPaymentMethodId]);

  return (
    <div style={{ display: 'block', margin: '0 auto' }}>
      <Cards
        showAddCard={showAddCard}
        setShowAddCard={setShowAddCard}
      />
      <div>
        <CardContainer>
          <Button
            className="payNowButton"
            style={{
              backgroundColor: '#FFFFFF',
              color: '#31AD31',
              minHeight: 0,
            }}
            // fullWidth
            onClick={() => createOrder()}
            disabled={!paymentMethodId}
            pending={sending}
          >
            <ConfirmSvg />
          </Button>
          <PreAmount>£1</PreAmount>
          <CardHolder>
            {preAuthMessageVisible && (
              <Card>
                <PreAuthTag>Pre-payment authorization*</PreAuthTag>
                <PreAuthText>
                  Full payment will not be taken until completion of
                  repair
                </PreAuthText>
                <CloseButton
                  onClick={() => setPreAuthMessageVisible(false)}
                >
                  <CloseSquare />
                </CloseButton>
              </Card>
            )}
            {cardlist &&
              cardlist.data.map((carddetail: PaymentMethod) => (
                <Card
                  key={carddetail.paymentMethodId}
                  onClick={() => {
                    setPaymentMethodId(carddetail.paymentMethodId);
                  }}
                  style={{ display: 'flex' }}
                >
                  <div style={{ flexGrow: 2 }}>
                    <span color="textPrimary">
                      {carddetail.brand}
                    </span>
                    <br />
                    <span color="black">
                      ****-****-****-{carddetail.last4}
                    </span>
                    <br />
                    <span color="black">{carddetail.nameOnCard}</span>
                  </div>
                  {paymentMethodId === carddetail.paymentMethodId && (
                    <div
                      style={{
                        flexGrow: 1,
                        paddingTop: '10px',
                        paddingRight: '10px',
                        textAlign: 'right',
                      }}
                    >
                      <SelectorSvg />
                    </div>
                  )}
                </Card>
              ))}

            <Card>
              <button
                onClick={() => setShowAddCard(true)}
                type="button"
                style={{
                  background: 'none',
                  color: 'inherit',
                  border: 'none',
                  padding: 0,
                  font: 'inherit',
                  cursor: 'pointer',
                  outline: 'inherit',
                }}
              >
                <SpeedDialIcon /> Add Payment Method
              </button>
            </Card>
            <h4 style={{ textAlign: 'center' }}>Payment Details</h4>
            <QuoteDetails quoteSummery={quoteSummery} />
          </CardHolder>
        </CardContainer>
      </div>
    </div>
  );
}
